<template>

  <v-dialog class="new-issue-popup"
            :value="visiblePopup"
            fullscreen
            @keydown.esc="onCloseClickButton"
            @click:outside="onCloseClickButton"
  >
    <v-card class="popup-wrapper">
      <issue-add-edit-popup-core-content
        :currentIssue="newIssue"
        :title="'issueDataPopup.createNewIssue'"
        @closed="onCloseClickButton"
        @saved="save"/>
    </v-card>
  </v-dialog>

</template>

<script>

import { mapGetters } from 'vuex';

import { ADD_ISSUE } from '@/store/issue/actionTypes';
import IssueAddEditPopupCoreContent from '@/components/issue/IssueAddEditPopupCoreContent.vue';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'NewIssuePopup',
  mixins: [disableOuterScrollOnPopupVisible],
  components: { IssueAddEditPopupCoreContent },
  props: {
    visiblePopup: {
      type: Boolean,
      required: true,
    },
    projectId: null,
  },
  data() {
    return {
      newIssue: {
        securityRisk: null,
        description: null,
        probability: null,
        severity: null,
        riskScore: null,
        comment: null,
        projectId: this.projectId,
        serviceProviderWorkerId: null,
      },
    };
  },
  computed: {
    ...mapGetters(['profile']),
  },
  methods: {
    onCloseClickButton() {
      this.clearNewIssue();
      this.$emit('closed');
    },
    async save(resultIssue) {
      const issue = resultIssue;
      issue.serviceProviderWorkerId = this.profile.id;
      const options = { newIssue: issue };
      await this.$store.dispatch(ADD_ISSUE, options);
      this.$emit('saved');
    },
    clearNewIssue() {
      Object.keys(this.newIssue).forEach(key => {
        this.newIssue[key] = null;
      });
      this.newIssue.projectId = this.projectId;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

</style>
